import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { langEN, langKO } from "./translationResources";

// Define shared translation type
export type TranslationResources = {
  game: string;
  team: string;
  individual: string;
  cooperative: string;
  J2H: {
    title: string;
  };
};

const resources = {
  en: langEN,
  ko: langKO,
};

// 브라우저 언어 감지
const getBrowserLanguage = (): string => {
  const browserLang = navigator.language || navigator.languages?.[0] || "ko";
  const langCode = browserLang.split("-")[0]; // 'ko-KR' -> 'ko'

  // 지원하는 언어인지 확인
  if (langCode === "en") return "en";
  return "ko"; // 기본값
};

// 저장된 언어 설정 불러오기
const getSavedLanguage = (): string | null => {
  try {
    const savedLang = localStorage.getItem("lingple-language");
    if (savedLang === "en" || savedLang === "ko") {
      return savedLang;
    }
  } catch (error) {
    console.warn("Failed to load language from localStorage:", error);
  }
  return null;
};

// 언어 설정 저장하기
export const saveLanguage = (lang: string): void => {
  try {
    localStorage.setItem("lingple-language", lang);
  } catch (error) {
    console.warn("Failed to save language to localStorage:", error);
  }
};

// 초기 언어 결정
const getInitialLanguage = (): string => {
  return getSavedLanguage() || getBrowserLanguage();
};

i18n
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources,
    lng: getInitialLanguage(), // 저장된 언어 또는 브라우저 언어
    fallbackLng: "ko", // 폴백 언어
    keySeparator: ".", // We use dots to separate keys (optional)
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
